var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mx-2",attrs:{"fab":"","x-small":"","color":"default"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v(_vm._s(_vm.mdiReply))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }